export const tb2definitions = [
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed1e"
    },
    label: "Age Days",
    description: "Days since the chargeback.",
    type: "Number",
    accepts: "[any]",
    placeholder: "agedays",
    value: "[[rp.Chargeback.AgeDays]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed20"
    },
    label: "AVS Match Code",
    description: "Returns the AVS Match Code for a given order.",
    type: "String",
    accepts: "[any]",
    placeholder: "avscode",
    value: "[[rp.RepresentmentTransactionInfo.AVSCode]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed21"
    },
    label: "Billing Address",
    description: "Returns the billing address provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "billingaddress",
    value: "[[rp.OrderInfo.BillingContact.Address]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed24"
    },
    label: "ARN",
    description: "ARN for the chargeback.",
    type: "String",
    accepts: "[any]",
    placeholder: "arn",
    value: "[[rp.Chargeback.ARN]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed22"
    },
    label: "Billing Name",
    description: "Returns the billing name provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "billingname",
    value: "[[rp.OrderInfo.BillingContact.Name]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed2b"
    },
    label: "Car Return Date",
    description: "Returns when the car was returned.",
    type: "Date",
    accepts: "[any]",
    placeholder: "carreturndate",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.OrderInfo.CarReturnDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed2d"
    },
    label: "Chargeback Amount",
    description: "The amount charged back to the customer.",
    type: "Currency",
    accepts: "[any]",
    placeholder: "cbamount",
    value: "[[rp.Chargeback.Amount]]",
    format: "float",
    __v: 0,
    prefix: "$"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed2f"
    },
    label: "Chargeback Age Days",
    description: "The number of days since the chargeback was requested.",
    type: "Number",
    accepts: "[any]",
    placeholder: "cbagedays",
    value: "[[rp.Chargeback.AgeDays]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed32"
    },
    label: "Cancelled",
    description: "Indicates whether the order was cancelled.",
    type: "Boolean",
    accepts: "true, false, null",
    placeholder: "cancelled",
    value: "[[rp.RepresentmentTransactionInfo.Cancelled]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed36"
    },
    label: "Chargeback Date",
    description: "The date of the chargeback.",
    type: "Date",
    accepts: "[any]",
    placeholder: "cbdate",
    value: "[[rp.Chargeback.DisputeDate]]",
    format: "dddd, MMM DD, YYYY",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed39"
    },
    label: "Chargeback Accepted",
    description: "Indicates if the chargeback was accepted or not.",
    type: "String",
    accepts: "accepted",
    placeholder: "cbaccepted",
    value: "[[rp.Chargeback.FoughtNotFought]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed42"
    },
    label: "Merchant Account Id",
    description: "Unknown....",
    type: "Number",
    accepts: "[any]",
    placeholder: "merchantaccountid",
    value: "[[merchant.MerchantAccountId]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed4b"
    },
    label: "Cancellation Policy URL",
    description: "The url for merchant's cancellation policy page.",
    type: "String",
    accepts: "[any]",
    placeholder: "cancelpolicyurl",
    value: "[[merchant.CancellationPolicyUrl]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed4c"
    },
    label: "Merchant Delivery Type",
    description: "The type of delivery being handled by the merchant",
    type: "Number",
    accepts: "[0-6] Downloadable Digital Good=0, Access to Website/Application=1, Shipped=2, Online Order -&gt; Physical Pickup=3, Email=4, Text=5, Other=6",
    placeholder: "merchantdeliverytype",
    value: "[[merchant.DeliveryType_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed52"
    },
    label: "Merchant Zip Code",
    description: "Zip code associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantzip",
    value: "[[merchant.Zip]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed53"
    },
    label: "Product Name",
    description: "Returns the first product's name in the Products array.",
    type: "String",
    accepts: "[any]",
    placeholder: "productname",
    value: "[[rp.OrderInfo.Products|aq|first|Name]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed58"
    },
    label: "Refundable",
    description: "Returns whether the item is refundable.",
    type: "Boolean",
    accepts: "true, false, null",
    placeholder: "refundable",
    value: "[[rp.OrderInfo.Refundable]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed61"
    },
    label: "Shipping ID",
    description: "Returns the shipping ID associated with the order.",
    type: "Number",
    accepts: "[any]",
    placeholder: "shippingid",
    value: "[[rp.OrderInfo.ShippingContact.Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed64"
    },
    label: "Shipping Zip",
    description: "Returns the shipping zip provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "shippingzip",
    value: "[[rp.OrderInfo.ShippingContact.Zip]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed66"
    },
    label: "Shipping State",
    description: "Returns the shipping state provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "shippingstate",
    value: "[[rp.OrderInfo.ShippingContact.State]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed68"
    },
    label: "Support Phone",
    description: "The phone number for merchant's customer support.",
    type: "String",
    accepts: "[any]",
    placeholder: "supportphone",
    value: "[[merchant.SupportPhone]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed69"
    },
    label: "Terms Text",
    description: "The text of the merchant's terms policy.",
    type: "String",
    accepts: "[any]",
    placeholder: "terms",
    value: "[[merchant.TermsText]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed6c"
    },
    label: "Transaction Date",
    description: "Returns the date of the transaction.",
    type: "Date",
    accepts: "[any]",
    placeholder: "trxdate",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.RepresentmentTransactionInfo.TransactionDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed74"
    },
    label: "Merchant Company",
    description: "Company associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "company",
    value: "[[merchant.Company]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed70"
    },
    label: "Refund Status Id",
    description: "Id Number of the refund status",
    type: "String",
    accepts: "String",
    placeholder: "refundstatus_id",
    value: "[[rp.RepresentmentTransactionInfo.RefundStatus_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed71"
    },
    label: "Hours Between Transaction and Dispute",
    description: "Hours elapsed between trx and dispute.",
    type: "Number",
    accepts: "[any]",
    placeholder: "hoursbetweentrxanddispute",
    value: "[[rp.Chargeback.TimeBetweenTransactionAndDispute]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed77"
    },
    label: "BIN",
    description: "BIN  number from chargeback.",
    type: "Number",
    accepts: "[any]",
    placeholder: "bin",
    value: "[[rp.Chargeback.BIN]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed7b"
    },
    label: "Reason Code",
    description: "The reason code listed in merchant record.",
    type: "String",
    accepts: "[any]",
    placeholder: "reasoncode",
    value: "[[rp.Chargeback.ReasonCode]]",
    __v: 0
  },
  {
    _id: {
      $oid: "629e5128b54a01175833cfd3"
    },
    label: "Document Type",
    placeholder: "documenttype",
    value: "[[rp.Documents|aq|first|DocumentType]]",
    accepts: "Shipping Provider Proof, Fulfillment, Usage History, Login History, Proof of Site or App Access, Proof of Product Download, Proof of Activation or Usage, Warranty Registration, Evidence Service Was Provided, Customer Service Records0, Signed Contract1, Call Transcript, Service was Provided, Customer Acquisition, Fraud Tools, Purchase Process, Purchase Terms, Transaction History, Invoice, Evidence Cardholder is Related to Customer, Product Image, Product Description, Proof Customer No Longer Wishes to Dispute, Identity Verification, CDRN/Alert, Cancelled, Other, Evidence of Refund",
    type: "String",
    __v: 0
  },
  {
    _id: {
      $oid: "62ab5665e4fe131f900531a2"
    },
    label: "Processor Id",
    placeholder: "processor_id",
    value: "[[merchant.Processor.Id]]",
    type: "Number",
    __v: 0
  },
  {
    _id: {
      $oid: "634efb36f0b07d199822a7e6"
    },
    label: "Chargeback Id",
    placeholder: "cbid",
    value: "[[rp.Chargeback.ChargebackId]]",
    __v: 0
  },
  {
    _id: {
      $oid: "63bc5c763f0f1d2c3449f887"
    },
    label: "Prior Refund",
    placeholder: "priorrefund",
    value: "[[rp.Chargeback.PriorRefund]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed1d"
    },
    label: "Add-Ons Included",
    description: "Indicates whether add-ons were included.",
    type: "Boolean",
    accepts: "true, false, null",
    placeholder: "addons",
    value: "[[rp.RepresentmentTransactionInfo.AddOns]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed1c"
    },
    label: "Alert Received",
    description: "Indicates whether an alert was received.",
    type: "Boolean",
    accepts: "True, False, Null",
    placeholder: "alertreceived",
    value: "[[rp.RepresentmentTransactionInfo.ExternalAlertId]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed2a"
    },
    label: "Cancel Date",
    description: "Returns the date of when the order was cancelled.",
    type: "Date",
    accepts: "[any]",
    placeholder: "canceldate",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.RepresentmentTransactionInfo.CancelDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed28"
    },
    label: "Business Category",
    description: "Returns the business category.",
    type: "String",
    accepts: "ECOMMERCE, MOTO, Services, Digital, Airline Travel, Hotel, Vacation Rental, Car Rental, Other",
    placeholder: "businesscategory",
    value: "[[merchant.AccountClassification]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed27"
    },
    label: "Billing Zip",
    description: "Returns the billing zip provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "billingzip",
    value: "[[rp.OrderInfo.BillingContact.Zip]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed2e"
    },
    label: "Car Rental Date",
    description: "Returns when the car was rented.",
    type: "Date",
    accepts: "[any]",
    placeholder: "carrentaldate",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.OrderInfo.CarRentalDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed30"
    },
    label: "Card Brand",
    description: "Returns the brand of credit card used (Visa, Mastercard, etc)",
    type: "String",
    accepts: "[any]",
    placeholder: "cardbrand",
    value: "[[rp.Chargeback.CardBrand]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed33"
    },
    label: "Cancellation Policy Text",
    description: "The text of the merchant's Cancellation policy.",
    type: "String",
    accepts: "[any]",
    placeholder: "cancelpolicy",
    value: "[[merchant.CancellationPolicyText]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed38"
    },
    label: "CVV Code",
    description: "The CVS or CVV code associated with the order.",
    type: "String",
    accepts: "[any]",
    placeholder: "cvv",
    value: "[[rp.RepresentmentTransactionInfo.CVSMatchCode_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed46"
    },
    label: "Merchant City",
    description: "City associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantcity",
    value: "[[merchant.City]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed48"
    },
    label: "Merchant Email",
    description: "Email address associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantemail",
    value: "[[merchant.Email]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed49"
    },
    label: "Merchant Descriptor 1",
    description: "Descriptor field 1 for the merchant",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantdescrip1",
    value: "[[merchant.Descriptor1]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed4a"
    },
    label: "Merchant Descriptor 2",
    description: "Descriptor field 2 for the merchant",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantdescrip2",
    value: "[[merchant.Descriptor2]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed4d"
    },
    label: "Merchant DBA",
    description: "Returns the merchant DBA.",
    type: "String",
    accepts: "[any]",
    placeholder: "dba",
    value: "[[merchant.DBA]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed4f"
    },
    label: "Merchant Name",
    description: "Name of the associated merchant",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantname",
    value: "[[merchant.Name]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed55"
    },
    label: "Product Type Id",
    description: "The type of product that was sold.",
    type: "Number",
    accepts: "[0-3] Physical Goods=0, Services=1, Digital Goods=2, Other=3",
    placeholder: "producttype",
    value: "[[merchant.ProductType_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed5e"
    },
    label: "Return Attempted Too Late",
    description: "Indicates if the customer attempted to return the product too late.",
    type: "Boolean",
    accepts: "True, False, Null",
    placeholder: "returntoolate",
    value: "[[rp.OrderInfo.ReturnAttemptTooLate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed65"
    },
    label: "Shipping Address",
    description: "Returns the shipping address provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "shippingaddress",
    value: "[[rp.OrderInfo.ShippingContact.Address]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed67"
    },
    label: "Support Email",
    description: "The email address for merchant's customer support.",
    type: "String",
    accepts: "[any]",
    placeholder: "supportemail",
    value: "[[merchant.SupportEmail]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed75"
    },
    label: "Days Between Cancellation and Chargeback",
    description: "Number of days between cancellation and chargeback.",
    type: "Number",
    accepts: "[any]",
    placeholder: "daysbetweencancellationandcb",
    value: "[[rp.DaysBetweenCancellationAndCB]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed76"
    },
    label: "Days Between Refund and Chargeback",
    description: "Number of days between refund and chargeback.",
    type: "Number",
    accepts: "[any]",
    placeholder: "daysbetweenrefundandcb",
    value: "[[rp.DaysBetweenRefundAndCB]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed6d"
    },
    label: "Transaction Amount",
    description: "Returns the amount of the transaction.",
    type: "Currency",
    accepts: "[any]",
    placeholder: "trxamount",
    format: "float",
    value: "[[rp.RepresentmentTransactionInfo.Amount]]",
    __v: 0,
    prefix: "$"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed78"
    },
    label: "Merchant Account Name",
    description: "The name of the merchant account.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantaccountname",
    value: "[[rp.Chargeback.MerchantAccountName]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed80"
    },
    label: "Product Description",
    description: "Returns the first product's description in the Products array.",
    type: "String",
    accepts: "[any]",
    placeholder: "productdescription",
    value: "[[rp.OrderInfo.Products|aq|first|Description]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed81"
    },
    label: "Product SKU",
    description: "Returns the first product's SKU in the Products array.",
    type: "String",
    accepts: "[any]",
    placeholder: "productsku",
    value: "[[rp.OrderInfo.Products|aq|first|Sku]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed83"
    },
    label: "Document Notes",
    description: "Returns the notes for the first document in the Documents array.",
    type: "String",
    accepts: "[any]",
    placeholder: "documentnote",
    value: "[[rp.Documents|aq|first|Notes]]",
    __v: 0
  },
  {
    _id: {
      $oid: "6298dd147a83112020f03ed8"
    },
    placeholder: "abcabc",
    label: "ABC ABC",
    value: "[[rp.abc.abc]]",
    __v: 0
  },
  {
    _id: {
      $oid: "634edbacf0b07d199822a766"
    },
    label: "Representment Id",
    placeholder: "representmentid",
    value: "[[rp.Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "634efd80f0b07d199822a81a"
    },
    label: "Reference Transaction Amount",
    placeholder: "reftxnamt",
    value: "[[rp.Chargeback.ReferenceTransactionAmount]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed1b"
    },
    label: "Age Hours",
    description: "Hours since the chargeback.",
    type: "Number",
    accepts: "[any]",
    placeholder: "agehours",
    value: "[[rp.Chargeback.AgeHours]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed29"
    },
    label: "Business Description",
    description: "Returns the business description.",
    type: "String",
    accepts: "[any]",
    placeholder: "businessdescrip",
    value: "[[merchant.BusinessDescription]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed2c"
    },
    label: "Cancel Attempt Too Late",
    description: "Indicates whether the cancel attempt was too late.",
    type: "Boolean",
    accepts: "true, false, null",
    placeholder: "canceltoolate",
    value: "[[rp.OrderInfo.CancelAttemptTooLate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed31"
    },
    label: "Chargeback Too Late",
    description: "Indicates whether the chargeback request was filed too late.",
    type: "Boolean",
    accepts: "True, False, Null",
    placeholder: "cbtoolate",
    value: "[[rp.ChargebackArrivedTooLate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed34"
    },
    label: "Checkin Date",
    description: "The date customer checked in.",
    type: "Date",
    accepts: "[any]",
    placeholder: "checkindate",
    value: "[[rp.CheckInDate]]",
    __v: 0,
    format: "dddd, MMM DD, YYYY"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed3a"
    },
    label: "Country ISO",
    description: "Indicates the country where the transaction originated from.",
    type: "String",
    accepts: "[any] Most likely US or UK",
    placeholder: "country",
    value: "[[rp.Chargeback.CountryISO]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed3c"
    },
    label: "Customer Email Address",
    description: "Email address associated with the customer order.",
    type: "String",
    accepts: "[any]",
    placeholder: "customeremail",
    value: "[[rp.OrderInfo.Email]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed3b"
    },
    label: "Checkout Date",
    description: "The date customer checked out.",
    type: "Date",
    accepts: "[any]",
    placeholder: "checkoutdate",
    value: "[[rp.CheckOutDate]]",
    __v: 0,
    format: "dddd, MMM DD, YYYY"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed3f"
    },
    label: "Last Four of CC",
    description: "Last four digits of the credit card used.",
    type: "String",
    accepts: "[any]",
    placeholder: "lastfour",
    value: "[[rp.Chargeback.LastFour]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed40"
    },
    label: "Days Between Transaction and Dispute",
    description: "Days elapsed between trx and dispute.",
    type: "Number",
    accepts: "[any]",
    placeholder: "daysbetweentrxanddispute",
    value: "[[rp.Chargeback.DaysBetweenTransactionAndDispute]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed44"
    },
    label: "Dispute Date",
    description: "The date the chargeback dispute was filed by the customer.",
    type: "Date",
    accepts: "[any]",
    placeholder: "disputedate",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.Chargeback.TransactionDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed45"
    },
    label: "Dispute Amount",
    description: "The amount being disputed by the customer.",
    type: "Number",
    accepts: "[any]",
    placeholder: "disputeamt",
    value: "[[rp.DisputeAmount]]",
    __v: 0,
    prefix: "$"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed47"
    },
    label: "Merchant Contact",
    description: "Contact person associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantcontact",
    value: "[[merchant.Contact]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed4e"
    },
    label: "Merchant Id",
    description: "The id of the merchant hamdling the order.",
    type: "Number",
    accepts: "[any]",
    placeholder: "merchantid",
    value: "[[merchant.Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed51"
    },
    label: "Merchant State",
    description: "State associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantstate",
    value: "[[merchant.State]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed56"
    },
    label: "Processor Name",
    description: "Description needed.",
    type: "String",
    accepts: "[any]",
    placeholder: "processor",
    value: "[[merchant.Processor.Name]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed5a"
    },
    label: "Refund Policy URL",
    description: "The url for merchant's refund policy page.",
    type: "String",
    accepts: "[any]",
    placeholder: "refundpolicyurl",
    value: "[[merchant.RefundPolicyUrl]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed5d"
    },
    label: "Return Policy URL",
    description: "The url for merchant's return policy page.",
    type: "String",
    accepts: "[any]",
    placeholder: "returnpolicyurl",
    value: "[[merchant.ReturnPolicyUrl]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed5f"
    },
    label: "Return Policy Text",
    description: "The text of the merchant's return policy.",
    type: "String",
    accepts: "[any]",
    placeholder: "returnpolicy",
    value: "[[merchant.ReturnPolicy]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed63"
    },
    label: "Shipping Name",
    description: "Returns the shipping name provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "shippingname",
    value: "[[rp.OrderInfo.ShippingContact.Name]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed6a"
    },
    label: "Transaction Cancelled Reason",
    description: "Describes why the transaction was cancelled.",
    type: "String",
    accepts: "[any]",
    placeholder: "cancelledreason",
    value: "[[rp.RepresentmentTransactionInfo.CancelReason]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed6b"
    },
    label: "Terms URL",
    description: "The url for merchant's terms page.",
    type: "String",
    accepts: "[any]",
    placeholder: "termsurl",
    value: "[[merchant.TermsUrl]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed7f"
    },
    label: "Product Quantity",
    description: "Returns the first product's quantity in the Products array.",
    type: "Number",
    accepts: "[any]",
    placeholder: "productquantity",
    value: "[[rp.OrderInfo.Products|aq|first|Quantity]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed7c"
    },
    label: "Last CS Contact Date",
    description: "The last date customer service was contacted.",
    type: "Date",
    accepts: "[any]",
    placeholder: "CScontactdate",
    value: "[[rp.RepresentmentTransactionInfo.LastCustomerServiceContactDate]]",
    __v: 0,
    format: "dddd, MMM DD, YYYY"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed7a"
    },
    label: "First Name",
    description: "First name as listed in merchant record.",
    type: "String",
    accepts: "[any]",
    placeholder: "firstname",
    value: "[[rp.Chargeback.FirstName]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed82"
    },
    label: "Was Product Returned",
    description: "Returns whether the first product in the Products array was returned.",
    type: "Boolean",
    accepts: "[any]",
    placeholder: "wasreturned",
    value: "[[rp.OrderInfo.Products|aq|first|WasReturned]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62b9ee94dae64a22f4beb390"
    },
    label: "Document Type 1",
    placeholder: "documenttype_1",
    value: "[[rp.Documents|aq|second|DocumentType]]",
    type: "String",
    accepts: "String",
    __v: 0
  },
  {
    _id: {
      $oid: "634f00acf0b07d199822a864"
    },
    label: "Chargeback Transaction Date",
    placeholder: "cbtransactiondate",
    value: "[[rp.Chargeback.TransactionDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed1f"
    },
    label: "Authorization Code",
    description: "Auth Code for the chargeback.",
    type: "String",
    accepts: "[any]",
    placeholder: "authcode",
    value: "[[rp.Chargeback.AuthorizationCode]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed23"
    },
    label: "Billing ID",
    description: "Returns the billing ID associated with the order.",
    type: "Number",
    accepts: "[any]",
    placeholder: "billingid",
    value: "[[rp.OrderInfo.BillingContact.Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed25"
    },
    label: "Billing City",
    description: "Returns the billing city provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "billingcity",
    value: "[[rp.OrderInfo.BillingContact.City]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed26"
    },
    label: "Billing State",
    description: "Returns the billing state provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "billingstate",
    value: "[[rp.OrderInfo.BillingContact.State]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed35"
    },
    label: "Charge Type ID",
    description: "Defines the nature of the charge performed.",
    type: "Number",
    accepts: "0=Recurring; 1=Straight Sales; 2=Other; What is empty field?",
    placeholder: "chargetypeid",
    value: "[[merchant.ChargeType_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed37"
    },
    label: "Customer Service Phone",
    description: "The phone number for merchant's customer service dept.",
    type: "String",
    accepts: "[any]",
    placeholder: "customerservicephone",
    value: "[[merchant.CustomerServicePhone]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed3d"
    },
    label: "Date Shipped",
    description: "Returns when the product shipped.",
    type: "Date",
    accepts: "[any]",
    placeholder: "dateshipped",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.OrderInfo.DateShipped]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed3e"
    },
    label: "Date Delivered",
    description: "Returns when the product was delivered.",
    type: "Date",
    accepts: "[any]",
    placeholder: "datedelivered",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.OrderInfo.DateDelivered]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed41"
    },
    label: "Merchant Address",
    description: "Address associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantaddress",
    value: "[[merchant.Address]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed43"
    },
    label: "Flight Date",
    description: "Returns the date of the flight.",
    type: "Date",
    accepts: "[any]",
    placeholder: "flightdate",
    format: "dddd, MMM DD, YYYY",
    value: "[[rp.OrderInfo.FlightDate]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed50"
    },
    label: "Merchant Phone",
    description: "Phone number associated with the merchant.",
    type: "String",
    accepts: "[any]",
    placeholder: "merchantphone",
    value: "[[merchant.Phone]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed54"
    },
    label: "Reason Code (Number)",
    description: "Numeric indicator for why the transaction is being disputed.",
    type: "Number",
    accepts: "[any]",
    placeholder: "reasoncodenumber",
    value: "[[rp.ReasonCode]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed57"
    },
    label: "Reason Code Category",
    description: "Indicates the reason why the transaction is being disputed.",
    type: "String",
    accepts: "[any] (Often Fraud)",
    placeholder: "rc",
    value: "[[rp.ReasonCodeCagtegory]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed59"
    },
    label: "Reason Description",
    description: "More details on why the transaction is being disputed.",
    type: "String",
    accepts: "[any]",
    placeholder: "reasondescrip",
    value: "[[rp.ReasonCodeDescription]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed5b"
    },
    label: "Refund Amount",
    description: "The amount of any refund issued.",
    type: "Currency",
    accepts: "[any]",
    placeholder: "refundamount",
    value: "[[rp.RepresentmentTransactionInfo.RefundAmount]]",
    format: "float",
    __v: 0,
    prefix: "$"
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed5c"
    },
    label: "Refund Date",
    description: "The date of any refund issued.",
    type: "Date",
    accepts: "[any]",
    placeholder: "refunddate",
    value: "[[rp.RepresentmentTransactionInfo.RefundDate]]",
    format: "dddd, MMM DD, YYYY",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed60"
    },
    label: "Refund Policy Text",
    description: "The text of the merchant's refund policy.",
    type: "String",
    accepts: "[any]",
    placeholder: "refundpolicy",
    value: "[[merchant.RefundPolicyText]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed62"
    },
    label: "Shipping City",
    description: "Returns the shipping city provided by the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "shippingcity",
    value: "[[rp.OrderInfo.ShippingContact.City]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed73"
    },
    label: "Reason Code Allowed Days To Dispute",
    description: "Indicates the how many days are allowed for the dispute.",
    type: "Number",
    accepts: "[any]",
    placeholder: "daystofilecb",
    value: "[[rp.ReasonCodeAllowedDaysToDispute]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed6f"
    },
    label: "Was Customer Service Contacted",
    description: "Indicates whether the customer contacted customer service.",
    type: "Boolean",
    accepts: "True, False, Null",
    placeholder: "wascscontacted",
    value: "[[rp.RepresentmentTransactionInfo.WasCustomerServiceContacted]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed6e"
    },
    label: "Alert Provider",
    description: "Indicates the issuer of the alert.",
    type: "String",
    accepts: "[any]",
    placeholder: "alertprovider",
    value: "[[rp.RepresentmentTransactionInfo.AlertProvider]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed72"
    },
    label: "Website URL",
    description: "The url for merchant's web site.",
    type: "String",
    accepts: "[any]",
    placeholder: "weburl",
    value: "[[merchant.WebsiteUrl]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed79"
    },
    label: "Currency",
    description: "The currency being used.",
    type: "String",
    accepts: "[any]",
    placeholder: "currency",
    value: "[[rp.Chargeback.Currency]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed7d"
    },
    label: "ThreeD (3ds) Secure ID",
    description: "The 3ds secure ID value.",
    type: "String",
    accepts: "[any]",
    placeholder: "3ds",
    value: "[[rp.RepresentmentTransactionInfo.ThreeDSecure_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "62980feeab36c31cc0a9ed7e"
    },
    label: "Product Id",
    description: "Returns the first product's id in the Products array.",
    type: "Other",
    accepts: "[any]",
    placeholder: "productid",
    value: "[[rp.OrderInfo.Products|aq|first|Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "634ec3bbf0b07d199822a719"
    },
    label: "No Show",
    placeholder: "noshow",
    value: "[[rp.OrderInfo.NoShow]]",
    __v: 0
  },
  {
    _id: {
      $oid: "634efe7af0b07d199822a82f"
    },
    label: "Consumer Name",
    placeholder: "consumername",
    value: "[[rp.Chargeback.ConsumerName]]",
    __v: 0
  },
  {
    _id: {
      $oid: "65de6c0ba2846c9f3539545c"
    },
    label: "Processor Case Id",
    description: "Description coming soon",
    type: "String",
    accepts: "[any]",
    placeholder: "procaseid",
    value: "[[rp.Chargeback.ProcessorCaseId]]"
  },
  {
    _id: {
      $oid: "6640cd7f696378bb7a5387bd"
    },
    label: "Device Id",
    type: "String",
    accepts: "[any]",
    placeholder: "device_id",
    value: "[[rp.RepresentmentTransactionInfo.DeviceId]]",
    __v: 0
  },
  {
    _id: {
      $oid: "6640cde8696378bb7a5387c2"
    },
    label: "Ship To Different",
    type: "Boolean",
    accepts: "[true|false]",
    placeholder: "ship_different",
    value: "[[rp.OrderInfo.ShipToDifferent]]",
    __v: 0
  },
  {
    _id: {
      $oid: "6640ce4f696378bb7a5387c7"
    },
    label: "IP Address",
    type: "String",
    accepts: "[any]",
    placeholder: "ip_address",
    value: "[[rp.OrderInfo.IPAddress]]",
    __v: 0
  },
  {
    _id: {
      $oid: "6640ce95696378bb7a5387cc"
    },
    label: "CRM Username",
    type: "String",
    accepts: "[any]",
    placeholder: "crm_username",
    value: "[[rp.Chargeback.CRMUserName]]",
    __v: 0
  },
  {
    _id: {
      $oid: "66609e1e741bfd9df636cb63"
    },
    label: "AVS Code Description",
    description: "The description for a given AVS Code.",
    type: "String",
    accepts: "",
    placeholder: "avscodedescription",
    value: "[[rp.RepresentmentTransactionInfo.AVSCodeDescription]]",
    __v: 0
  },
  {
    _id: {
      $oid: "66b540aecb432f8544945682"
    },
    label: "Quantity Purchased",
    description: "Quantity of items purchased for the transaction.",
    type: "Number",
    accepts: "[number]",
    placeholder: "Quantity",
    value: "[[rp.OrderInfo.Quantity]]",
    __v: 0
  },
  {
    _id: {
      $oid: "670414e5803b8a07d71c6aec"
    },
    label: "Shipping Company",
    description: "Name of the shipping company",
    type: "Number",
    accepts: "[1-4] USPS=1, UPS=2, FED-EX=3, DHL=4",
    placeholder: "shipper_id",
    value: "[[rp.OrderInfo.Shipper_Id]]",
    __v: 0
  },
  {
    _id: {
      $oid: "670457da803b8a07d71c6aff"
    },
    label: "Document Type ID",
    description: "The numeric value for the document types uploaded as supporting documents.",
    type: "Number",
    accepts: "[1-28] Shipping Provider Proof=1, Fulfillment=2, Usage History=3, Login History=4, Proof of Site or App Access=5, Proof of Product Download=6, Proof of Activation or Usage=7, Warranty Registration=8, Evidence Service Was Provided=9, Customer Service Records=10, Signed Contract=11, Call Transcript=12, Service was Provided=13, Customer Acquisition=14, Fraud Tools=15, Purchase Process=16, Purchase Terms=17, Transaction History=18, Invoice=19, Evidence Cardholder is Related to Customer=20, Product Image=21, Product Description=22, Proof Customer No Longer Wishes to Dispute=23, Identity Verification=24, CDRN/Alert=25, Cancelled=26, Other=27, Evidence of Refund=28",
    placeholder: "documenttype_id",
    value: "TBD",
    __v: 0
  },
  {
    _id: {
      $oid: "675ccc16edc6d2c5a90ada3b"
    },
    label: "Customer Phone Number",
    description: "The phone number of the customer.",
    type: "String",
    accepts: "[any]",
    placeholder: "customerphone",
    value: "[[rp.OrderInfo.Phone]]",
    __v: 0
  },
  {
    _id: {
      $oid: "676082b9edc6d2c5a90ae178"
    },
    label: "Document Title",
    description: "This is for the document title for Supporting Documents. Currently a free from filed, expected to become a dropdown.",
    type: "String",
    accepts: "[any]",
    placeholder: "DocumentTitle",
    value: "[[rp.Documents|aq|first|Title]]",
    __v: 0
  },
  {
    _id: {
      $oid: "6760842aedc6d2c5a90ae181"
    },
    label: "Meets CE3 Criteria",
    description: "This flag identifies transactions that meet Compelling Evidence 3.0 Criteria.",
    type: "Boolean",
    accepts: "[true|false]",
    placeholder: "MeetsCE3Criteria",
    value: "[[rp.Chargeback.MeetsCE3Criteria]]",
    __v: 0
  },
  {
    _id: {
      $oid: "67a37188a00ee92dcfcae952"
    },
    label: "Document Type (any)",
    description: "Provides a comma separated string of all Document Type values for any given representment so that they can be queried against.",
    type: "String",
    accepts: "",
    placeholder: "documenttype_any",
    value: "[[rp.Documents|aq|any|DocumentType]]",
    __v: 0
  }
]